<div class="alert-bottom d-flex flex-row justify-content-start align-items-start p-4 my-3">
  <fa-icon [icon]="['fas', 'circle-info']" [size]="'lg'"></fa-icon>
  <div class="alert-text ms-3">
    {{ infoDisplayKey | translate }}
  </div>
</div>
